import React , { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ProductDetails from './pages/ProductDetails';
import ContactUs from './pages/ContactUs';

import useScrollToHash from './components/useScrollToHash';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import CartView from './components/CartView';

import Payment from './pages/Payment';
import ThankYou from './pages/ThankYou';

import Login from './auth/Login';
import axios from 'axios';  
import ForgotPassword from './auth/ForgotPassword';
import ResetPassword from './auth/ResetPassword';
import UserDetails from './auth/UserDetails';
import UserDashboard from './auth/UserDashboard';
import SupplierDetails from './auth/SupplierDetails';
import SupplierDashboard from './auth/SupplierDashboard';
import SupplierStepper from './auth/SupplierStepper';

import { useAuth , AuthProvider  } from './context/AuthContext';
import { useCart , CartProvider  } from './context/CartContext';
import { LanguageProvider } from "./context/LanguageContext";
import AppContent from "./AppContent";
import SupplierLogin from './auth/SupplierLogin';

import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import { useTranslation } from 'react-i18next';


const googleCaptcha = process.env.REACT_APP_GOOGLE_CAPTCHA_KEY;

const App = () => {

  console.log("google captcha ", googleCaptcha); 
      const { i18n } = useTranslation();
    
      useEffect(() => {
    document.documentElement.lang = i18n.language;
    document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
  }, [i18n.language]);

  return (
      <GoogleReCaptchaProvider reCaptchaKey={googleCaptcha}>

    <AuthProvider>
    <LanguageProvider>  
       <CartProvider>
      <Router>
   
      <AppContent />

      </Router>
        </CartProvider>
    </LanguageProvider>
    </AuthProvider>

    </GoogleReCaptchaProvider>
  );
};

export default App;
